export default {
    CLASSIC: "CLSC",
    CLASSIC_PLUS: "CLPL",
    ELITE: "ELIT",
    ELITE_PLUS: "ELPL",
}
